import React from "react";
import SingleSelectNew from "../SelectField/SingleSelectNew";
import { getTimezoneOptions } from "../../utils/countryConfig";

/**
 * Country-scoped timezone dropdown. US keeps existing 4-zone list unchanged.
 */
const TimezoneSelect = ({
  country = "US",
  value,
  onChange,
  name = "timeZone",
  placeholder = "Select Timezone",
  className,
  contentClass,
  itemClass,
  tabIndex,
  id,
}) => {
  const options = getTimezoneOptions(country);

  return (
    <SingleSelectNew
      id={id || name}
      name={name}
      value={value || ""}
      placeholder={placeholder}
      onChange={onChange}
      options={options}
      className={className}
      contentClass={contentClass}
      itemClass={itemClass}
      tabIndex={tabIndex}
    />
  );
};

export default TimezoneSelect;
